import { RootState } from 'editor/src/store/index';
import isPluginEnabled from 'editor/src/store/plugins/selector/isPluginEnabled';
import { PluginName } from 'editor/src/store/plugins/types';

const getShowPersonalizationBar = (state: RootState): boolean => {
  const { showPersonalizationBar } = state.editorModules.preview;

  // Short-circuit: only check plugin status if the flag is true
  if (!showPersonalizationBar) {
    return false;
  }

  return isPluginEnabled(state, PluginName.AIPersonalization);
};

export default getShowPersonalizationBar;
